var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { DecoKey } from '../basic/decoration';
import { IG_EL } from '../formatter';
import { createCardDOM, createInlineCardDOM } from '../schema';
var createShadowWrapper = function (inline) {
    var dom;
    if (inline)
        dom = createInlineCardDOM();
    else
        dom = createCardDOM();
    dom.setAttribute(IG_EL, 'true');
    return dom;
};
var getShadows = function (state, key, start, end) {
    var specMatch;
    if (key) {
        if (typeof key === 'string') {
            specMatch = function (_spec) { return _spec.key === key; };
        }
        else if (typeof key === 'function') {
            specMatch = key;
        }
    }
    var decorations = DecoKey.getState(state).find(start, end, specMatch);
    return decorations;
};
// data needs to provide pos, shadow
var insertShadow = function (state, dispatch, data, inline) {
    var tr = state.tr;
    var fixPos = 0;
    if (inline && data.editable) {
        tr = state.tr.insert(data.pos, state.schema.text('\u200B\u200B'));
        fixPos = 1;
    }
    dispatch(tr.setMeta(DecoKey, {
        action: 'add',
        data: __assign(__assign({}, data), { pos: data.pos + fixPos, spec: __assign(__assign({}, data.spec), { shadowType: inline ? 'inline' : 'block' }) }),
        dom: createShadowWrapper(inline),
    }));
};
var removeShadow = function (state, dispatch, key) {
    var decorations = getShadows(state, key);
    if (!decorations.length)
        return;
    var _a = decorations[0], from = _a.from, to = _a.to, spec = _a.spec;
    var $pos = state.tr.doc.resolve(from);
    var fixPos = 0;
    if ($pos.nodeBefore && $pos.nodeBefore.textContent.match(/\u200B$/)) {
        fixPos = -1;
    }
    dispatch(state.tr.setMeta(DecoKey, {
        action: 'remove',
        data: {
            spec: { key: key },
        },
    }));
    return {
        spec: spec,
        from: from + fixPos,
        to: to + fixPos,
    };
};
// data must have from, to,
var appendShadow = function (state, dispatch, data, inline) {
    dispatch(state.tr.setMeta(DecoKey, {
        action: inline ? 'appendInline' : 'appendNode',
        data: data,
    }));
};
export { appendShadow, getShadows, insertShadow, removeShadow };
//# sourceMappingURL=shadow.js.map